import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { MainLayoutModule } from './layouts/main-layout/main-layout.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from '@app-core/interceptors/auth/auth.interceptor';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsArray } from '@app-core/store/effects';
import { appReducers } from '@app-core/store/app.reducers';
import { environment } from '@environments/environment';
import { AgmCoreModule } from '@agm/core';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { NgxZendeskWebwidgetModule } from 'ngx-zendesk-webwidget';
import { ZendeskConfig } from '@shared/class/zenDesk.class';
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MainLayoutModule,
    AppRoutingModule,
    ReactiveFormsModule,
    NgxZendeskWebwidgetModule.forRoot(ZendeskConfig),
    GoogleTagManagerModule.forRoot({
      id: environment.TAG_MANAGER,
    }),
    StoreModule.forRoot(appReducers, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    EffectsModule.forRoot(EffectsArray),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    AgmCoreModule.forRoot({
      language: 'en',
      apiKey: environment.GOOGLE_API,
      libraries: ['places'],
      apiVersion: 'quarterly',
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
